import { IPublicGetUserResponse } from '../../repositories/users/entities/UserDataModels/PublicGetUserResponse';
import { TUser } from '../../types/user';

export const prepareUser = (userResponse: IPublicGetUserResponse): TUser => {
  if (!userResponse.user || !userResponse.user.cianUserId || !userResponse.user.realtyUserId) {
    return {
      isAuthenticated: false,
    };
  }

  return {
    ...userResponse.user,
    isAuthenticated: true,
  };
};
